
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/kamerki",
      function () {
        return require("private-next-pages/[region]/kamerki.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/kamerki"])
      });
    }
  